/**
 * Рекурсивный рендеринг ветки дерева истории (корень + потомки).
 * Зависит от render-helpers.js (_countDescendants) и render-item.js (_renderHistoryItemRow).
 * # ⛓️ CURSOR_ANCHOR:search:history-render-branch
 */

/**
 * Рендерит ветку (корень + потомки) как плоскую последовательность DOM-рядов
 * с data-depth для визуальных отступов.
 */
function _renderBranch(node, activeChain) {
  var hasChildren = node.children.length > 0;
  var rootInChain = activeChain && activeChain[node.item.id];
  // Root's hi-child-conn: thick only if root is in chain AND has a child in chain
  var rootChildInChain = false;
  if (rootInChain && hasChildren) {
    for (var ri = 0; ri < node.children.length; ri++) {
      if (activeChain && activeChain[node.children[ri].item.id]) { rootChildInChain = true; break; }
    }
  }
  var html = window._renderHistoryItemRow(node.item, {
    depth: 0,
    rootId: node.rootId,
    isRoot: true,
    hasChildren: hasChildren,
    activeChain: activeChain,
    totalDescendants: hasChildren ? window._countDescendants(node) : 0,
    laterSiblingInChain: false,
    hasChildInChain: rootChildInChain,
    activeContinuations: {}
  });

  function renderChildren(children, depth, parentContinuations, activeContinuations, parentNodeInChain) {
    parentContinuations = parentContinuations || [];
    activeContinuations = activeContinuations || {};

    // Pre-compute: for each child index, is there an active-chain sibling at or after it?
    // This determines whether the vertical connector at the parent's depth is on the active path.
    var chainAtOrAfter = new Array(children.length);
    var foundChain = false;
    for (var j = children.length - 1; j >= 0; j--) {
      if (activeChain && activeChain[children[j].item.id]) foundChain = true;
      chainAtOrAfter[j] = foundChain;
    }

    children.forEach(function(ch, idx) {
      var isLast = (idx === children.length - 1);
      var selfInChain = activeChain && activeChain[ch.item.id];
      // laterSiblingInChain: is there a chain-sibling AFTER this one?
      // Controls hi-conn-v: thick only if the vertical line leads to a later chain-sibling.
      var laterSibling = parentNodeInChain && (idx + 1 < children.length) && chainAtOrAfter[idx + 1];
      // hasChildInChain: does this node have at least one child in the active chain?
      // Controls hi-child-conn: thick only if path continues downward.
      var childInChain = false;
      if (selfInChain && ch.children.length > 0) {
        for (var ci2 = 0; ci2 < ch.children.length; ci2++) {
          if (activeChain && activeChain[ch.children[ci2].item.id]) { childInChain = true; break; }
        }
      }
      html += window._renderHistoryItemRow(ch.item, {
        depth: depth,
        rootId: node.rootId,
        isRoot: false,
        hasChildren: ch.children.length > 0,
        activeChain: activeChain,
        lastInBranch: isLast,
        continuations: parentContinuations,
        parentInActiveChain: parentNodeInChain,
        laterSiblingInChain: laterSibling,
        hasChildInChain: childInChain,
        activeContinuations: activeContinuations
      });
      if (ch.children.length > 0) {
        var childContinuations = parentContinuations.slice();
        var childActiveCont = {};
        for (var k in activeContinuations) {
          childActiveCont[k] = activeContinuations[k];
        }

        if (!isLast) {
          childContinuations.push(depth - 1);
          // Continuation at depth-1 is active only if a LATER sibling is in the active chain
          // (the path must continue past this subtree to reach the later sibling)
          var laterInChain = (idx + 1 < children.length) && chainAtOrAfter[idx + 1];
          if (parentNodeInChain && laterInChain) {
            childActiveCont[depth - 1] = true;
          }
        }
        renderChildren(ch.children, depth + 1, childContinuations, childActiveCont, selfInChain);
      }
    });
  }
  if (hasChildren) renderChildren(node.children, 1, [], {}, rootInChain);

  return html;
}

window._renderBranch = _renderBranch;
